import VerticalTabs from "../../utils/components/VerticalTabs";
import { Outlet, useParams } from "react-router";
import { auth } from "../../App/routes";
import { MdAccountCircle } from "react-icons/md";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../utils/components/Breadcrumbs";
import API from "../../utils/API";
import Loading from "../../utils/components/Loading";
import toastr from "toastr";
import { confirmAlert } from "react-confirm-alert";
import AlertModal from "../../utils/components/AlertModal";

const Account = ({ user, translate }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const [userInfo, setUserInfo] = useState(null);
  const [isUpdatingAvatar, setIsUpdatingAvatar] = useState(false);
  const { id } = useParams();

  const handleUserChange = (e) => {
    const input = e.target;
    let file = input.files[0];

    if (!file) return;

    const reader = new FileReader();

    reader.onloadend = function () {
      setIsUpdatingAvatar(true);
      if (reader.result.includes("data:image/")) {
        const avatar = reader.result.split(",")[1];
        updateUserData({ avatar }).then(({ data: res }) => {
          if (res.data.avatar) {
            setUserInfo({ ...userInfo, avatar: res.data.avatar });
          }
        }).finally(() => {
          setIsUpdatingAvatar(false);
          input.value = null;
        });
      }
    };
    reader.readAsDataURL(file);
  };

  useEffect(() => {
    API.getUserData(id || user.id).then(({ data: res }) => {
      const { data } = res;
      setUserInfo({ ...data });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const updateUserData = async (data, callback) => {
    if (!userInfo) return;

    const params = {
      name: userInfo.name,
      email: userInfo.email,
      accept: userInfo.accept,
      avatar: userInfo.avatar,
      lang: userInfo.lang,
      notification_email: userInfo.notification_email,
      notification_push: userInfo.notification_push,
      role: userInfo.role,
      status: userInfo.status,
      title: userInfo.title,
      ...data,
    };

    if (userInfo?.company?.id) params.company_id = userInfo?.company?.id;

    return API.updateUserData(
      params,
      id || user.id,
      parseInt(userInfo?.company_id)
    )
      .then(({ data: res }) => {
        const { data, message } = res;
        setUserInfo({ ...data });
        if (message) {
          toastr.clear();
          toastr.success(message);
        }

        if (callback) callback(true);
        return { data: res };
      })
      .catch(() => {
        if (callback) callback(false);
      })
      .finally(() => {
        setIsUpdatingAvatar(false);
      });
  };

  const removeAvatar = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <AlertModal
          message="Kaldırmak istediğinize emin misiniz?"
          buttons={[
            {
              label: "Kaldır",
              onClick: () => {
                updateUserData({ avatar: null })
                  .then(({ data: res }) => {
                    setUserInfo({ ...userInfo, avatar: res.data.avatar });

                    onClose();
                  })
                  .catch(onClose);
              },
              classNames: "btn-danger",
            },
            {
              label: "İptal",
              onClick: onClose,
              classNames: "btn-secondary",
            },
          ]}
        />
      ),
    });
  };

  return (
    <div className="container-fluid">
      <div className="row mb-4">
        <div className="col-12">
          <Breadcrumbs data={breadcrumbs} />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-3 verti d-flex flex-column align-items-start shadow rounded bg-white px-0">
          <VerticalTabs
            headerNode={
              <div className="col-12 d-flex flex-column align-items-center mb-5">
                <div
                  className="profile-icon px-3 d-flex justify-content-center align-items-center position-relative rounded-circle overflow-hidden"
                  style={{
                    paddingTop: userInfo?.avatar ? "calc(100% - 1rem)" : "0",
                    width: "calc(100% - 1rem)",
                  }}
                >
                  {isUpdatingAvatar && (
                    <div
                      className="loading-area position-absolute h-100 bg-black bg-opacity-50 rounded-circle d-flex justify-content-center align-items-center"
                      style={{
                        top: 0,
                        left: "1rem",
                        width: "calc(100% - 2rem)",
                      }}
                    >
                      <Loading />
                    </div>
                  )}
                  {userInfo?.avatar ? (
                    <img
                      src={userInfo?.avatar}
                      alt="User avatar"
                      className="logo rounded-circle w-100 h-100 position-absolute"
                      style={{ top: 0, left: 0, objectFit: "cover" }}
                    />
                  ) : (
                    <MdAccountCircle className="account-icon text-gray" />
                  )}
                </div>
                <div className="text-center mt-4">
                  <p className="fs-4 fw-medium">{userInfo?.name}</p>
                  <p>
                    <label
                      className={`fs-6 ${
                        isUpdatingAvatar
                          ? "text-secondary cursor--default"
                          : "text-decoration-underline text-primary"
                      }`}
                      htmlFor="profileImage"
                    >
                      {translate("account.change_avatar")}
                    </label>
                    <input
                      className="d-none"
                      type="file"
                      id="profileImage"
                      name="profileImage"
                      accept="image/*"
                      onChange={handleUserChange}
                      disabled={isUpdatingAvatar}
                    />
                  </p>
                </div>

                {userInfo?.avatar && (
                  <div className="text-center">
                    <p
                      className="mb-0 text-danger fw-bold text-decoration-underline"
                      role="button"
                      onClick={removeAvatar}
                    >
                      {translate("account.remove_avatar")}
                    </p>
                  </div>
                )}
              </div>
            }
            nodes={auth.account.pages.map((item) => ({
              id: item.id,
              icon: item.icon,
              customTitle: translate(`account.${item.name}`),
              link: auth.account.link + (item.link ? `/${item.link}` : ""),
            }))}
          />
        </div>
        <div className="col-12 col-md-7 bg-white ms-0 ms-md-5 shadow rounded">
          <Outlet
            context={{
              breadcrumbs,
              setBreadcrumbs,
              userInfo,
              setUserInfo,
              updateUserData,
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Account;
